import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:ring-misc-focus focus-visible:ring-[2px] focus-visible:ring-offset-1 aria-invalid:ring-system-negative-2/20 dark:aria-invalid:ring-system-negative-2/40 aria-invalid:border-system-negative-2 select-none",
  {
    variants: {
      variant: {
        default: "bg-secondary-2 text-neutral-1 shadow-xs hover:bg-secondary-3",
        destructive:
          "bg-system-negative-2 text-neutral-1 shadow-xs hover:bg-system-negative-3 focus-visible:ring-system-negative-2/20 dark:focus-visible:ring-system-negative-2/40",
        outline:
          "border border-secondary-2 bg-neutral-1 text-secondary-2 shadow-xs hover:bg-secondary-3 hover:text-neutral-1 dark:bg-neutral-2 dark:border-neutral-4 dark:hover:bg-neutral-3",
        secondary: "border border-secondary-4 bg-secondary-6 text-neutral-12 shadow-xs hover:bg-secondary-5",
        danger: "bg-label-red-2 text-neutral-1 shadow-xs hover:bg-system-negative-3",
        outlineDanger: "border border-label-red-2 bg-neutral-1 text-label-red-2 shadow-xs hover:bg-system-negative-3 hover:text-neutral-1",
        ghost: "border border-secondary-4 bg-secondary-6 text-label-red-2 hover:bg-secondary-5 hover:text-system-negative-3 dark:hover:bg-neutral-4",
        primary: "bg-primary-3 text-neutral-1 shadow-xs hover:bg-primary-2",
        primaryOutline: "border border-primary-3 bg-neutral-1 text-neutral-12 shadow-xs hover:bg-primary-2 hover:text-neutral-1",
        primaryGhost: "border border-primary-4 bg-primary-8 text-neutral-12 shadow-xs hover:bg-primary-6 hover:border-primary-4 hover:text-neutral-12",
        primaryDanger: "border border-primary-4 bg-primary-8 text-label-red-2 shadow-xs hover:bg-primary-6 hover:border-primary-4 hover:text-label-red-2",
        link: "text-primary-3 underline-offset-4 hover:underline",
        icon: "border-0 bg-transparent text-neutral-12 shadow-none",
      },
      size: {
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-3.5",
        default: "h-9 px-4 py-2 has-[>svg]:px-4",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4.5",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

function Button({ className, variant, size, asChild = false, ...props }) {
  const Comp = asChild ? Slot : "button"

  return <Comp data-slot="button" className={cn(buttonVariants({ variant, size, className }))} {...props} />
}

export { Button, buttonVariants }
